import { jsx as _jsx } from "react/jsx-runtime";
import * as Flags from 'country-flag-icons/react/3x2';
import React from 'react';
const flagComponents = Flags;
const resolveFlagCountryCode = (countryCode) => {
    return countryCode.toUpperCase();
};
/**
 * Renders a real SVG flag for an ISO-3166 alpha-2 country code.
 * Regional-indicator emoji render as letters on Windows Chrome, so absence is
 * safer than an emoji fallback.
 */
export const CountryFlag = ({ countryCode, className }) => {
    const Flag = flagComponents[resolveFlagCountryCode(countryCode)];
    if (!Flag) {
        return null;
    }
    return _jsx(Flag, { className: className, "aria-hidden": "true", focusable: "false" });
};
//# sourceMappingURL=CountryFlag.js.map